import { Controller } from 'stimulus';

// A common pattern in the app is to have a form in an offcanvas, but to also have
// a select from the form duplicated on the page for quick access.
//
// To simplify this and prevent bugs, this controller can be attached to the body,
// making the select within the form a target and attaching the `submit` event to the
// on-page input (with the inputs name attribute removed)
//
// When the on-page input is used, it'll update the select that's inside of the form,
// then submit the form
export default class extends Controller {
  static targets = ['select'];

  submit({ target }) {
    if (target.multiple) {
      // For multiple selects, disable the select to prevent multiple form submissions and
      // update all selected values
      target.disabled = true;
      const selectedValues = Array.from(target.selectedOptions).map(
        (option) => option.value
      );
      Array.from(this.selectTarget.options).forEach(
        (option) => (option.selected = selectedValues.includes(option.value))
      );
    } else {
      this.selectTarget.value = target.value;
    }

    target.form.submit();
  }
}
